import React from "react";
import HiringManagerCard from "../components/HiringManagerCard";
import SectionSubTitle from "../components/SectionSubTitle";

export default ({
  hiringManager,
  colorSectionHeaderText,
  colorSectionText
}) => (
  <>
    <SectionSubTitle
      title={"The Hiring Manager"}
      colorSectionHeaderText={colorSectionHeaderText}
    />
    <div
      style={{ color: colorSectionText }}
      className="grid grid-cols-2 gap-2 md:gap-4 xl:gap-6"
    >
      {hiringManager.map((manager) => (
        <HiringManagerCard
          key={manager.id}
          image={manager.image}
          name={manager.name}
          title={manager.title}
          url={manager.url}
        />
      ))}
    </div>
  </>
);
